import { Button, Col, Row } from 'antd';
import { CfSimCompareResult, SimHistoryInfo } from 'domain/entities/SimulateEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SIM_TYPE } from 'utilities/constants/COMMON';
import { SimCompareComponent } from './components/SimCompareComponent';
import { SimHistoryModal } from './components/SimHistoryModal';

const CU05902Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { id1, id2 } = useParams();
    const [data, setData] = React.useState<CfSimCompareResult>();
    const [modalData, setModalData] = React.useState<SimHistoryInfo[]>([]);
    const [isOpenedModal, setIsOpenedModal] = React.useState<boolean>(false);
    const { simulateUseCase } = props;
    const { data1, data2 } = location.state as any;
    const navigate = useNavigate();

    useEffect(() => {
        const modalData: SimHistoryInfo[] = [];
        if (data1 && data1.type == SIM_TYPE.HISTORY) {
            modalData.push(data1);
        }
        if (data2 && data2.type == SIM_TYPE.HISTORY) {
            modalData.push(data2);
        }
        setModalData(modalData);
        getDataCompare();
    }, []);

    const getDataCompare = async () => {
        try {
            dispatch(startFetching());
            const response = await simulateUseCase.getDataCompare({
                id1: Number(id1),
                id2: Number(id2),
            });
            const data = response.result;
            data.cfSim1 = {
                ...data.cfSim1,
                simCalcDiv: data1.type,
                simulationTitle: data1.simulationTitle,
            };
            data.cfSim2 = {
                ...data.cfSim2,
                simCalcDiv: data2.type,
                simulationTitle: data2.simulationTitle,
            };
            setData(data);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const gotoSimulate = (id: number) => {
        setIsOpenedModal(false);
        if (id != -1) {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_02}/${id}`);
        } else {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_01}`);
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-059-02-container"
        >
            <PageTitle title="シミュレーション比較" />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="form-container w-full">
                    <div className="flex flex-col justify-between items-start w-full">
                        <SimCompareComponent data={data} />
                        <Row className="w-full py-[56px] justify-center">
                            <Col span={12} className="w-full">
                                <Button
                                    type="primary"
                                    size="large"
                                    onClick={() => setIsOpenedModal(true)}
                                    disabled={modalData.length == 0}
                                    style={{
                                        height: '56px',
                                        backgroundColor: '#4BCAE5',
                                    }}
                                    className="button-container w-full"
                                >
                                    条件を変えてシミュレーション
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
                <SimHistoryModal
                    data={modalData}
                    open={isOpenedModal}
                    onOk={(value) => gotoSimulate(value)}
                    onCancel={() => setIsOpenedModal(false)}
                />
            </section>
        </div>
    );
};

export default CU05902Page;
